export function initShowcaseTabs(): void {
  const heroTabs = document.querySelectorAll<HTMLButtonElement>('.hero-tab');
  const heroPanels = document.querySelectorAll<HTMLElement>('.hero-panel');

  if (heroTabs.length === 0 || heroPanels.length === 0) return;

  const activeClasses = [
    'bg-white',
    'dark:bg-brand-darkCard',
    'text-brand-royal',
    'dark:text-brand-cyan',
    'shadow-sm',
    'font-bold',
  ];

  const inactiveClasses = [
    'text-slate-600',
    'dark:text-slate-400',
    'font-semibold',
  ];

  heroTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const targetId = tab.getAttribute('data-target');
      if (!targetId) return;

      // Atualizar classes das abas
      heroTabs.forEach((t) => {
        t.classList.remove(...activeClasses);
        t.classList.add(...inactiveClasses);
      });

      tab.classList.add(...activeClasses);
      tab.classList.remove(...inactiveClasses);

      // Alternar visibilidade dos painéis correspondentes
      heroPanels.forEach((panel) => {
        if (panel.id === targetId) {
          panel.classList.remove('hidden');
          panel.classList.add('block');
        } else {
          panel.classList.add('hidden');
          panel.classList.remove('block');
        }
      });
    });
  });
}
